import { EquipmentWeight, SmallBodyGroupType } from 'fitbeat.models';
import { IWizardStep } from '../wizardManager';
export const ExplainerVideo = 'ExplainerVideo';
export const GeneralStrengthLevel = 'GeneralStrengthLevel';
export const SelectWeight = 'SelectWeight';
export const SelectDumbbellWeight = 'SelectDumbbellWeight';
export const StartAssessmentElite = 'StartAssessmentElite';
export const CompleteAssessment = 'CompleteAssessment';
export const ExplainAssessment = 'ExplainAssessment';
export const ExplainDumbbellAssessment = 'ExplainDumbbellAssessment';
export const ManualSelection = 'ManualSelection';
export const StrengthSettings = 'StrengthSettings';
export const StartAssessment = 'StartAssessment';
export const StartDumbbellAssessment = 'StartDumbbellAssessment';
export const SetUpHomeGym = 'SetUpHomeGym';

interface IAssessmentStep {
  titleKey: string;
  descriptionKey?: string;
  buttonKey: string;
  shouldShowProgressBar?: boolean;
}

export interface IStrengthRecommendation {
  suggestedStartingWeight?: EquipmentWeight;
  text: string;
  ratio: number;
  primaryMuscleMover: SmallBodyGroupType;
}

export interface IExplainerVideoStep extends IAssessmentStep {
  videoName: string;
  numberOfReps: number;
  recommendation?: IStrengthRecommendation;
  equipmentWeightLevel: number;
  primaryMuscleMover: SmallBodyGroupType;
  exerciseId: string;
  type: typeof ExplainerVideo;
}

export interface ISelectWeightStep extends IAssessmentStep {
  primaryMuscleMover: SmallBodyGroupType;
  exerciseId: string;
  equipmentWeightLevel: number;
  weightOptions: EquipmentWeight[];
}

export interface ISelectWeight extends ISelectWeightStep {
  type: typeof SelectWeight;
}
export interface ISelectDumbbellWeight  extends ISelectWeightStep {
  type: typeof SelectDumbbellWeight;
}

export interface IExplainAssessment extends IAssessmentStep {
  type: typeof ExplainAssessment;
}
export interface IExplainDumbbellAssessment extends IAssessmentStep {
  type: typeof ExplainDumbbellAssessment;
}

interface ICompleteAssessmentStep extends IAssessmentStep {
  type: typeof CompleteAssessment;
}

interface IManualSelectionStep extends IAssessmentStep {
  type: typeof ManualSelection;
}

interface IStrengthSettingsStep extends IAssessmentStep {
  type: typeof StrengthSettings;
}
interface IStartDumbbellAssessmentStep extends IAssessmentStep {
  type: typeof StartDumbbellAssessment;
}
interface IStartAssessmentEliteStep extends IAssessmentStep {
  type: typeof StartAssessmentElite;
  videoName: string;
}
interface IStartAssessmentStep extends IAssessmentStep {
  type: typeof StartAssessment;
  videoName: string;
}

interface ISetUpHomeGym extends IAssessmentStep {
  type: typeof SetUpHomeGym;
}

interface IGeneralStrengthLevelStep extends IAssessmentStep {
  type: typeof GeneralStrengthLevel;
}

export type StrengthAssessmentScreenTypes =
  | typeof ExplainerVideo
  | typeof SelectWeight
  | typeof CompleteAssessment
  | typeof StartAssessmentElite
  | typeof StrengthSettings;

export type WeightAsessmentSteps =
  | IExplainerVideoStep
  | ISelectWeight
  | ISelectDumbbellWeight
  | ICompleteAssessmentStep
  | IExplainAssessment
  | IManualSelectionStep
  | IStartAssessmentEliteStep
  | IStrengthSettingsStep
  | IStartAssessmentStep
  | IStartDumbbellAssessmentStep
  | IGeneralStrengthLevelStep
  | IExplainDumbbellAssessment
  | ISetUpHomeGym;

export type StrengthAssessmentSteps = StrengthAssessmentStep[];
export type StrengthAssessmentStep = IWizardStep<WeightAsessmentSteps>;

export const maleRatioPerStrengthDescription = {
  belowAverage: 0.4,
  average: 0.8,
  aboveAverage: 1.2,
  strengthAthlete: 1.6,
};

export const femaleRatioPerStrengthDescription = {
  belowAverage: 0.27,
  average: 0.54,
  aboveAverage: 0.8,
  strengthAthlete: 1.07,
};

export const bandWeightOptions: EquipmentWeight[] = [
  'X-LIGHT',
  'LIGHT',
  'MEDIUM',
  'HEAVY',
  'X-HEAVY',
  'XX-HEAVY',
];

export const dumbbellWeightOptions: EquipmentWeight[] = [
  '1kg',
  '2kg',
  '4kg',
  '5kg',
  '6kg',
  '8kg',
  '10kg',
  '12.5kg',
  '15kg',
  '20kg',
  '25kg',
  '32.5kg',
  '40kg',
];

export const manualStrengthAssessmentSteps: WeightAsessmentSteps[] = [
  {
    titleKey: 'manualSelectionTitle',
    type: ManualSelection,
    buttonKey: 'startAssessment',
  },
  {
    titleKey: 'completeAssessmentTitle',
    descriptionKey: 'completeAssessmentDescription',
    type: CompleteAssessment,
    buttonKey: 'done',
  },
];

export const uniBandstregthAssessmentSteps: WeightAsessmentSteps[] = [
  {
    titleKey: 'startEliteWeightAssessmentTitle',
    videoName: '',
    descriptionKey: 'startEliteWeightAssessmentDescription',
    type: StartAssessmentElite,
    buttonKey: 'startAssessment',
  },
  {
    titleKey: 'aimOfAssessmentTitle',
    type: ExplainAssessment,
    buttonKey: 'startFirstExercise',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-14944',
    numberOfReps: 15,
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Abdomen',
    exerciseId: '14944',
  },
  {
    titleKey: 'weightSelectionTitle',
    equipmentWeightLevel: 3,
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    weightOptions: bandWeightOptions,
    primaryMuscleMover: 'Abdomen',
    buttonKey: 'nextExercise',
    exerciseId: '14944',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-14708',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Shoulders',
    exerciseId: '14708',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    equipmentWeightLevel: 3,
    weightOptions: bandWeightOptions,
    type: SelectWeight,
    primaryMuscleMover: 'Shoulders',
    buttonKey: 'nextExercise',
    exerciseId: '14708',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-14970',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: ExplainerVideo,
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Upper Back & Traps',
    exerciseId: '14970',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    primaryMuscleMover: 'Upper Back & Traps',
    weightOptions: bandWeightOptions,
    equipmentWeightLevel: 3,
    buttonKey: 'nextExercise',
    exerciseId: '14970',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-15447',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: ExplainerVideo,
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Upper Legs',
    exerciseId: '15447',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    equipmentWeightLevel: 3,
    primaryMuscleMover: 'Upper Legs',
    weightOptions: bandWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '15447',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-14666',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Biceps',
    numberOfReps: 15,
    exerciseId: '14666',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    equipmentWeightLevel: 3,
    primaryMuscleMover: 'Biceps',
    weightOptions: bandWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '14666',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-14600',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 4,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Chest',
    numberOfReps: 15,
    exerciseId: '14600',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    equipmentWeightLevel: 4,
    primaryMuscleMover: 'Chest',
    weightOptions: bandWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '14600',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-14570',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 5,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    numberOfReps: 15,
    primaryMuscleMover: 'Glutes & Hips',
    exerciseId: '14570',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    equipmentWeightLevel: 5,
    type: SelectWeight,
    primaryMuscleMover: 'Glutes & Hips',
    weightOptions: bandWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '14570',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-20241',
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 4,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Lower Back & Lats',
    exerciseId: '20241',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    primaryMuscleMover: 'Lower Back & Lats',
    weightOptions: bandWeightOptions,
    equipmentWeightLevel: 4,
    buttonKey: 'nextExercise',
    exerciseId: '20241',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-14718',
    numberOfReps: 15,
    descriptionKey: 'explainWeightAssessmentDescription',
    equipmentWeightLevel: 3,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Triceps',
    exerciseId: '14718',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescription',
    type: SelectWeight,
    primaryMuscleMover: 'Triceps',
    weightOptions: bandWeightOptions,
    equipmentWeightLevel: 3,
    buttonKey: 'nextExercise',
    exerciseId: '14718',
  },
  {
    titleKey: 'completeAssessmentTitle',
    descriptionKey: 'completeAssessmentDescription',
    type: CompleteAssessment,
    buttonKey: 'done',
  },
];

export const dumbbellStregthAssessmentSteps: WeightAsessmentSteps[] = [
  {
    titleKey: 'startEliteWeightAssessmentTitle',
    descriptionKey: 'startEliteWeightAssessmentDescription',
    type: StartDumbbellAssessment,
    buttonKey: 'startAssessment',
  },
  {
    titleKey: 'aimOfDumbbellAssessmentTitle',
    type: ExplainDumbbellAssessment,
    buttonKey: 'startFirstExercise',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-6012',
    numberOfReps: 15,
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 12.5,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Abdomen',
    exerciseId: '6012',
  },
  {
    titleKey: 'weightSelectionTitle',
    equipmentWeightLevel: 12.5,
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    weightOptions: dumbbellWeightOptions,
    primaryMuscleMover: 'Abdomen',
    buttonKey: 'nextExercise',
    exerciseId: '6012',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-7495',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 8,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Shoulders',
    exerciseId: '7495',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    equipmentWeightLevel: 8,
    weightOptions: dumbbellWeightOptions,
    type: SelectDumbbellWeight,
    primaryMuscleMover: 'Shoulders',
    buttonKey: 'nextExercise',
    exerciseId: '7495',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-7001',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 6,
    type: ExplainerVideo,
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Upper Back & Traps',
    exerciseId: '7001',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    primaryMuscleMover: 'Upper Back & Traps',
    weightOptions: dumbbellWeightOptions,
    equipmentWeightLevel: 6,
    buttonKey: 'nextExercise',
    exerciseId: '7001',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-3796',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 25,
    type: ExplainerVideo,
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Upper Legs',
    exerciseId: '3796',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    equipmentWeightLevel: 25,
    primaryMuscleMover: 'Upper Legs',
    weightOptions: dumbbellWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '3796',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-956',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 8,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Biceps',
    numberOfReps: 15,
    exerciseId: '956',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    equipmentWeightLevel: 8,
    primaryMuscleMover: 'Biceps',
    weightOptions: dumbbellWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '956',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-2633',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 15,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Chest',
    numberOfReps: 15,
    exerciseId: '2633',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    equipmentWeightLevel: 15,
    primaryMuscleMover: 'Chest',
    weightOptions: dumbbellWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '2633',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-7248',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 15,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    numberOfReps: 15,
    primaryMuscleMover: 'Glutes & Hips',
    exerciseId: '7248',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    equipmentWeightLevel: 15,
    type: SelectDumbbellWeight,
    primaryMuscleMover: 'Glutes & Hips',
    weightOptions: dumbbellWeightOptions,
    buttonKey: 'nextExercise',
    exerciseId: '7248',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    numberOfReps: 15,
    videoName: 'strength-assessment-917',
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 15,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Lower Back & Lats',
    exerciseId: '917',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    primaryMuscleMover: 'Lower Back & Lats',
    weightOptions: dumbbellWeightOptions,
    equipmentWeightLevel: 15,
    buttonKey: 'nextExercise',
    exerciseId: '917',
  },
  {
    titleKey: 'explainWeightAssessmentTitle',
    videoName: 'strength-assessment-8386',
    numberOfReps: 15,
    descriptionKey: 'explainWeightAssessmentDescriptionDumbbells',
    equipmentWeightLevel: 8,
    type: 'ExplainerVideo',
    buttonKey: 'xRepsDone',
    primaryMuscleMover: 'Triceps',
    exerciseId: '8386',
  },
  {
    titleKey: 'weightSelectionTitle',
    descriptionKey: 'weightSelectionDescriptionDumbbells',
    type: SelectDumbbellWeight,
    primaryMuscleMover: 'Triceps',
    weightOptions: dumbbellWeightOptions,
    equipmentWeightLevel: 8,
    buttonKey: 'nextExercise',
    exerciseId: '8386',
  },
  {
    titleKey: 'completeAssessmentTitle',
    descriptionKey: 'completeAssessmentDescription',
    type: CompleteAssessment,
    buttonKey: 'done',
  },
];
